<!-- O <input> é descendente do <label>, então a associação é implícita
     (sem atributo `for`, que com id vazio quebraria o clique). -->
<label class="checkbox">
  <input
    class="checkbox__input"
    type="checkbox"
    [id]="id"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChange($event)"
  />
  <span class="checkbox__box">
    <svg class="checkbox__check"  viewBox="0 0 12 12" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6054 2.35535L4.12498 8.8361L1.39461 6.10497L0.85498 6.64497L3.85498 9.64497L4.12461 9.9026L4.39423 9.64497L11.1442 2.89497L10.6054 2.35535Z"
        fill="white" />
    </svg>
  </span>
  @if (label) {
    <span class="checkbox__label" [style.color]="labelColor">{{ label }}</span>
  }
</label>
